import remove from 'lodash/remove';
import api from '@/api';

export default {
  namespaced: true,

  state: {
    roles: [],
  },

  getters: {
  },

  actions: {
    async GetRoles({ commit }) {
      const { roles } = await api.role.getRoles();
      commit('SET_ROLES', roles);
      return roles;
    },
    async AddRole({ commit }, form) {
      const { role } = await api.role.addRole({ ...form });
      commit('ADD_ROLE', role);
      return role;
    },
    async UpdateRole({ commit }, form) {
      const { role } = await api.role.putRole({ ...form });
      commit('UPDATE_ROLE', role);
      return role;
    },
    async DeleteRole({ commit }, role) {
      await api.role.deleteRole({ roleId: role.id });
      commit('DELETE_ROLE', role);
    },
    async GetRolePermissions(_context, params) {
      const { permissions } = await api.role.getRolePermissions(params);
      return permissions;
    },
    async PutRolePermissions(_context, params) {
      const { msg } = await api.role.putRolePermissions(params);
      return msg;
    },
  },

  mutations: {
    SET_ROLES(state, roles) {
      state.roles = roles;
    },
    ADD_ROLE(state, role) {
      const { roles } = state;
      state.roles = [...roles, role];
    },
    UPDATE_ROLE(state, role) {
      const { roles } = state;
      const target = roles.find(item => item.id === role.id);
      if (target) {
        Object.assign(target, role);
        state.roles = [...roles];
      }
    },
    DELETE_ROLE(state, role) {
      const { roles } = state;
      remove(roles, item => item.id === role.id);
      state.roles = [...roles];
    },
  },
};
